import { ReferenceData } from './reference-data.model';

export class County extends ReferenceData {

  stateId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.stateId = data.stateId;
  }
}
